export default __webpack_public_path__ + "static/media/masterbed3.af5399f5.jpg";